var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _path9, _path10, _path11, _path12, _path13, _ellipse, _g3, _path14, _g4, _path15, _g5, _path16, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionErrorTtl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 148,
    viewBox: "0 0 185 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6541 75.6426C52.4506 89.302 65.6917 99.9119 81.7644 99.9191C97.837 99.9264 111.088 89.3285 112.897 75.6707L50.6541 75.6426Z",
    fill: "#FF7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5947 93.9878L86.4429 147.444",
    stroke: "#FF7B7B",
    strokeWidth: 1.57805
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5859 113.435L57.0361 107.433",
    stroke: "#FF7B7B",
    strokeWidth: 1.57805
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6137 59.272C43.9619 57.3438 45.6532 55.4379 47.6451 55.8556L60.1976 58.4883C61.416 58.7438 62.2884 59.8186 62.2878 61.0636L62.2799 78.5603C62.2792 80.0924 60.9743 81.2996 59.4468 81.1814L53.5526 80.7251C52.5021 80.6438 51.6015 79.9433 51.264 78.9451L44.6137 59.272Z",
    fill: "#FF7B7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7396 93.1139L119.02 147.177",
    stroke: "#FF7B7B",
    strokeWidth: 1.57805
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_527_14424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 91,
    width: 113,
    height: 54
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.76 119.538L146.722 102.24L158.496 91.6594C160.03 93.5011 163.556 99.0916 171.776 96.7283C179.359 94.548 184.048 99.7803 184.661 101.008L157.76 119.538Z",
    fill: "#041579"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7384 129.691L80.503 116.807L91.8106 120.626C91.0868 121.787 89.4943 124.715 88.9145 127.134C88.1899 130.158 91.1478 132.329 92.79 135.683C94.1039 138.367 92.239 142.543 91.1424 144.296L72.7384 129.691Z",
    fill: "#041579"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_527_14424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.76 119.538L146.722 102.24L158.496 91.6594C160.03 93.5011 163.556 99.0916 171.776 96.7283C179.359 94.548 184.048 99.7803 184.661 101.008L157.76 119.538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7384 129.691L80.503 116.807L91.8106 120.626C91.0868 121.787 89.4943 124.715 88.9145 127.134C88.1899 130.158 91.1478 132.329 92.79 135.683C94.1039 138.367 92.239 142.543 91.1424 144.296L72.7384 129.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.314 107.308C157.206 101.722 159.714 97.8923 164.707 91.4025L157.212 89.6238L144.78 99.4153L149.314 107.308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5861 120.096L79.2846 114.18L93.8131 120.104L91.5741 127.599C86.1424 125.988 83.0622 123.829 76.5861 120.096Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.591 117.827L165.161 111.468M184.07 98.9035L174.731 105.109M174.731 105.109C172.163 101.577 171.885 99.4769 172.565 95.6107M174.731 105.109L165.161 111.468M165.161 111.468C160.65 107.05 157.621 106.489 151.058 109.935M73.397 127.324L78.8525 131.592M92.6555 142.39L87.7916 138.585M87.7916 138.585C88.7226 134.988 90.1154 133.985 93.4487 133.185M87.7916 138.585L78.8525 131.592M78.8525 131.592C81.1207 128.093 80.6635 126.024 76.6212 122.131",
    stroke: "white",
    strokeWidth: 0.920527
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_527_14424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 34,
    width: 116,
    height: 94
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6355 53.7522L51.7321 53.7382C49.515 61.4521 48.2492 78.4857 60.9233 84.9088C73.5762 91.3212 91.3523 81.5799 98.698 75.8807C88.2878 83.9797 70.3287 106.186 70.9053 112.069C74.5547 117.952 91.4134 126.478 95.8842 127.137C97.4105 125.244 116.348 94.1829 125.626 78.8889C130.814 90.7439 134.033 97.1098 141.065 107.301C144.638 105.615 152.6 101.467 155.863 98.3651C159.126 95.2631 163.581 91.64 165.401 90.2162C159.576 79.496 145.901 55.4377 137.805 44.9664C127.685 31.8771 123.674 32.4671 112.954 37.7882C104.378 42.045 89.1685 50.2045 82.6355 53.7522Z",
    fill: "#2D2EC6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_527_14424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7321 53.7382L82.6355 53.7522C89.1685 50.2045 104.378 42.045 112.954 37.7882C123.674 32.4671 127.685 31.8771 137.805 44.9664C145.901 55.4377 159.576 79.496 165.401 90.2162C163.581 91.64 159.126 95.2631 155.863 98.3651C152.6 101.467 144.638 105.615 141.065 107.301C134.033 97.1098 130.814 90.7439 125.626 78.8889C116.348 94.1829 97.4105 125.244 95.8842 127.137C91.4134 126.478 74.5547 117.952 70.9053 112.069C67.4468 105.158 80.6931 89.0574 92.5443 79.9888C83.8218 85.0682 70.8089 89.9187 60.9233 84.9088C48.2492 78.4857 49.515 61.4521 51.7321 53.7382Z",
    fill: "#01B388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8481 56.5768L79.4131 55.1655M84.6746 52.0435L79.4131 55.1655M79.4131 55.1655L49.9556 56.5647M57.7825 51.1108C57.1389 54.3713 56.6636 59.3725 57.1848 64.2921M76.8199 118.91C81.2926 115.624 82.2828 106.88 85.9014 101.884C89.52 96.8885 101.884 92.0285 104.516 86.8352C107.148 81.642 104.453 81.1148 105.441 76.1838C106.43 71.2529 118.007 61.1981 113.734 58.0401C109.462 54.882 102.946 68.3582 103.212 62.4407C103.478 56.5231 96.9661 61.1886 93.0851 64.8689C89.2041 68.5493 75.652 84.3236 64.6084 78.401C59.8178 75.8318 57.8022 70.1193 57.1848 64.2921M113.739 47.3882C113.955 48.1065 114.166 48.8073 114.374 49.4926M125.823 80.4669C120.466 68.4185 117.934 61.2361 114.374 49.4926M114.374 49.4926L106.636 51.8166M66.0614 64.0019L71.7169 62.3035M71.7169 62.3035L72.0507 51.1173M71.7169 62.3035L74.9392 61.3358M74.9392 61.3358L74.9432 52.3021M74.9392 61.3358L106.636 51.8166M57.1848 64.2921C64.2489 62.2751 66.599 59.7623 67.316 52.2987M106.636 51.8166C114.859 42.1286 121.831 37.5291 123.603 45.7489C125.374 53.9687 123.333 61.1347 126.355 65.5415C129.378 69.9482 133.783 69.4242 136.083 73.5019C138.382 77.5795 133.709 87.7032 141.137 93.8873C148.564 100.071 142.316 102.173 150.992 110.724M87.2543 83.543C97.7773 77.7616 106.973 67.1259 112.09 60.1434",
    stroke: "#058868",
    strokeWidth: 0.920527
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0369 92.8154L46.6625 145.831",
    stroke: "#FF7B7B",
    strokeWidth: 1.57805
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6149 86.4916C83.0064 86.3363 84.0323 85.1181 83.9486 83.7205L83.514 76.4623C83.3726 74.1006 81.5094 72.2059 79.1503 72.025L53.5305 70.0603C51.4497 69.9007 50.0208 72.1118 51.0211 73.9433L58.392 87.4394C58.9037 88.3763 59.931 88.911 60.9919 88.7926L81.6149 86.4916Z",
    fill: "#FF7B7B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9072 83.0691L51.1062 78.6308C51.1624 78.8072 51.26 79.0262 51.3546 79.2534L83.9332 83.5961C83.9333 83.3622 83.9178 83.2169 83.9072 83.0691Z",
    fill: "#DD4949"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2921 70.4065L62.8505 80.0402L62.8902 80.2325L62.3767 80.3542L62.3025 79.9842L60.744 70.4094L61.2921 70.4065Z",
    fill: "#DD4949"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2964 9.52462C67.8213 12.8395 64.9795 13.4066 61.0965 12.4576C60.117 14.0358 57.5706 17.7602 55.2205 20.0324C52.9732 22.2052 50.617 20.2204 50.3551 18.1926C50.2464 17.3508 49.7833 16.1134 49.2063 15.4909C48.3551 14.5724 47.9256 13.1566 49.2025 11.9784C49.824 11.4049 50.0907 10.2765 49.8402 9.46882C49.3628 7.92956 49.6899 5.97313 52.2668 5.84207C52.9719 5.80621 53.59 5.25507 53.8258 4.58963C54.6368 2.30117 57.6245 1.01225 59.8719 2.7405C60.2929 3.06428 60.862 3.17124 61.357 2.97866C63.7989 2.02861 64.9086 3.4343 65.297 4.77301C65.4417 5.27203 65.8227 5.69051 66.2988 5.89872C67.3741 6.36899 68.5925 7.45841 68.2964 9.52462Z",
    fill: "#2F3030"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_527_14424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 4,
    width: 14,
    height: 21
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.7337,
    cy: 14.6942,
    rx: 6.63026,
    ry: 9.85068,
    transform: "rotate(-7.25944 59.7337 14.6942)",
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_527_14424)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.7337,
    cy: 14.6942,
    rx: 6.63026,
    ry: 9.85068,
    transform: "rotate(-7.25944 59.7337 14.6942)",
    fill: "#AE5848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8441 14.5382C54.7486 16.3378 53.5168 17.1897 52.0014 16.9996L52.0074 3.73904L61.9539 1.28086C64.4156 3.58678 68.8082 8.70986 66.6856 10.7548C64.0323 13.311 62.0452 8.95307 60.7185 10.3732C59.3918 11.7934 58.4447 11.5088 56.5506 11.0344C57.2121 14.4445 54.9396 12.7386 54.8441 14.5382Z",
    fill: "#2F3030"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_527_14424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 57,
    width: 16,
    height: 14
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7073 66.927L36.3684 58.9056C39.7224 57.4605 46.2319 57.5292 48.1382 58.5164C49.6633 59.3061 49.2988 60.9059 48.9258 61.6071C50.1695 62.6381 50.3907 63.3155 49.6477 64.7635C51.6188 67.8547 45.5029 70.0875 43.6616 70.6127C41.8203 71.1379 39.8487 69.0329 42.6767 67.5877C39.4152 68.1122 36.6715 67.3658 35.7073 66.927Z",
    fill: "#AE5848"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_527_14424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7073 66.927L36.3684 58.9056C39.7224 57.4605 46.2319 57.5292 48.1382 58.5164C49.6633 59.3061 49.2988 60.9059 48.9258 61.6071C50.1695 62.6381 50.3907 63.3155 49.6477 64.7635C51.6188 67.8547 45.5029 70.0875 43.6616 70.6127C41.8203 71.1379 39.8487 69.0329 42.6767 67.5877C39.4152 68.1122 36.6715 67.3658 35.7073 66.927Z",
    fill: "#AE5848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2929 67.5897L40.1119 68.376M46.2945 64.1049C47.1713 63.8642 49.2536 63.6722 50.5681 64.8301M46.2959 61.0803C48.0713 60.8838 49.3862 61.0817 50.7667 61.8713",
    stroke: "#843628",
    strokeWidth: 0.920527,
    strokeLinejoin: "bevel"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_527_14424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 0,
    width: 21,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2978 0.649135C73.5195 1.11086 76.7399 4.33416 80.9461 8.41268C81.3843 8.93889 81.4189 9.96463 77.7888 11.1728C74.1588 12.381 70.6664 9.50389 69.7028 7.81582C67.9927 9.06434 62.8631 11.1661 64.5084 7.94498C63.1273 8.60188 62.1605 7.14174 63.2598 6.36637C62.6021 6.69483 60.7613 6.16799 62.1428 4.59057C63.5243 3.01314 67.0762 0.187416 70.2978 0.649135Z",
    fill: "#AE5848"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_527_14424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2978 0.649135C73.5195 1.11086 76.7399 4.33416 80.9461 8.41268C81.3843 8.93889 81.4189 9.96463 77.7888 11.1728C74.1588 12.381 70.6664 9.50389 69.7028 7.81582C67.9927 9.06434 62.8631 11.1661 64.5084 7.94498C63.1273 8.60188 62.1605 7.14174 63.2598 6.36637C62.6021 6.69483 60.7613 6.16799 62.1428 4.59057C63.5243 3.01314 67.0762 0.187416 70.2978 0.649135Z",
    fill: "#AE5848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6653 5.84175C65.7711 6.41503 64.7059 7.22121 63.1273 8.33828M66.4827 3.86866C64.5756 4.52532 63.6306 5.2588 62.1418 6.75978",
    stroke: "#843628",
    strokeWidth: 0.920527,
    strokeLinejoin: "bevel"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_527_14424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 106,
    height: 70
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1815 53.9286L50.2798 53.9146C49.2941 52.6649 49.6086 50.7902 50.5103 47.0108L51.2351 43.3947L28.874 55.5487C30.9124 55.4181 35.8833 55.3941 39.4597 56.3425L37.1524 69.7549C32.2864 70.4979 20.161 72.0091 10.5875 72.11C-1.37941 72.2361 -3.60996 61.123 10.136 52.6472C23.882 44.1714 39.9297 35.1706 45.5854 32.5431C51.2412 29.9156 57.5544 27.8801 65.1818 27.5548C72.8091 27.2295 81.883 27.0363 88.0596 36.0472C82.6457 27.1024 75.8167 16.4914 73.0789 12.3039L83.2742 3.89229C84.6759 6.25999 90.0415 15.3099 100.291 32.5678C113.103 54.1403 98.3716 60.5115 90.4191 52.6835C84.0572 46.421 80.8893 43.4958 80.1005 42.816C81.8082 47.0249 82.958 51.2336 81.1815 53.9286Z",
    fill: "#01B388"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_527_14424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1815 53.9286L50.2798 53.9146C49.2941 52.6649 49.6086 50.7902 50.5103 47.0108L51.2351 43.3947L28.874 55.5487C30.9124 55.4181 35.8833 55.3941 39.4597 56.3425L37.1524 69.7549C32.2864 70.4979 20.161 72.0091 10.5875 72.11C-1.37941 72.2361 -3.60996 61.123 10.136 52.6472C23.882 44.1714 39.9297 35.1706 45.5854 32.5431C51.2412 29.9156 57.5544 27.8801 65.1818 27.5548C72.8091 27.2295 81.883 27.0363 88.0596 36.0472C82.6457 27.1024 75.8167 16.4914 73.0789 12.3039L83.2742 3.89229C84.6759 6.25999 90.0415 15.3099 100.291 32.5678C113.103 54.1403 98.3716 60.5115 90.4191 52.6835C84.0572 46.421 80.8893 43.4958 80.1005 42.816C81.8082 47.0249 82.958 51.2336 81.1815 53.9286Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8058 55.0909L30.8397 71.1331M31.0443 54.8924C27.8882 55.0006 19.1293 56.5177 13.5516 60.9337M51.3678 41.4225L50.1826 45.0383M58.8702 26.5002L62.2209 32.4194L65.2476 27.8181M65.2476 27.8181L69.125 32.1595L71.6258 27.0977M65.2476 27.8181C66.6478 33.4296 69.3809 47.9532 69.115 54.3179M84.0511 31.1142L94.1046 45.6499M75.3125 16.9736L86.8891 7.64202",
    stroke: "#F3A024",
    strokeWidth: 0.920527
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5365 37.4859C70.3268 36.7953 70.215 36.1097 70.1754 35.5789L75.9617 35.3185C76.0869 35.8343 76.1855 36.5207 76.1771 37.2254M70.5365 37.4859C71.0194 39.0766 72.0213 40.6945 73.8553 40.512C75.6492 40.3334 76.1591 38.7371 76.1771 37.2254M70.5365 37.4859L76.1771 37.2254M77.737 35.3193L81.3491 44.7892",
    stroke: "#F3A024",
    strokeWidth: 0.920527
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionErrorTtl);
export default __webpack_public_path__ + "static/media/action_error_ttl.67571eaa25591577760367cadfcf7891.svg";
export { ForwardRef as ReactComponent };